import { StrictMode } from 'react'
import { AppProvider } from 'contexts/app/AppProvider'
import { AuthProvider } from 'contexts/auth/AuthProvider'
import { ThemeProvider } from 'contexts/theme/ThemeProvider'
import { createRoot } from 'react-dom/client'
import App from './App'

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root container missing in index.html')
}

const root = createRoot(container)

root.render(
  <StrictMode>
    <AuthProvider>
      <AppProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </AppProvider>
    </AuthProvider>
  </StrictMode>
)
